(function () {
  function initStickyAtc() {
    var atcBtn = document.querySelector('[name="add"]');
    if (!atcBtn || document.getElementById('wb-sticky-atc')) return;

    // Build HTML
    var bar = document.createElement('div');
    bar.id = 'wb-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="wb-sticky-atc__inner">' +
        '<img class="wb-sticky-atc__thumb" src="" alt="">' +
        '<div class="wb-sticky-atc__info">' +
          '<span class="wb-sticky-atc__name"></span>' +
          '<div class="wb-sticky-atc__price-wrap">' +
            '<span class="wb-sticky-atc__price-current"></span>' +
            '<span class="wb-sticky-atc__price-old"></span>' +
            '<span class="wb-sticky-atc__badge"></span>' +
          '</div>' +
        '</div>' +
        '<select class="wb-sticky-atc__variant" aria-label="Variant"></select>' +
        '<button class="wb-sticky-atc__btn" type="button"></button>' +
      '</div>';
    document.body.appendChild(bar);

    var thumb       = bar.querySelector('.wb-sticky-atc__thumb');
    var nameEl      = bar.querySelector('.wb-sticky-atc__name');
    var priceNew    = bar.querySelector('.wb-sticky-atc__price-current');
    var priceOld    = bar.querySelector('.wb-sticky-atc__price-old');
    var badge       = bar.querySelector('.wb-sticky-atc__badge');
    var varSel      = bar.querySelector('.wb-sticky-atc__variant');
    var stickyBtn   = bar.querySelector('.wb-sticky-atc__btn');

    // Button label
    stickyBtn.textContent = (window.variantStrings && window.variantStrings.addToCart)
      ? window.variantStrings.addToCart
      : 'Toevoegen aan winkelwagen';

    // Product name
    var titleEl = document.querySelector('.product__title');
    if (titleEl) nameEl.textContent = titleEl.textContent.trim();

    // Thumbnail
    function updateThumb() {
      var img = document.querySelector('.protopimg-item.is-active img, .product__media-item.is-active img');
      if (!img) img = document.querySelector('.product__media img');
      if (img && img.src) { thumb.src = img.src; thumb.alt = img.alt || ''; }
    }
    updateThumb();

    // Prices + discount badge
    function parseAmount(str) {
      if (!str) return 0;
      return parseFloat(str.replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
    }

    function updatePrice() {
      var wrap = document.querySelector('.price');
      var onSale = wrap && wrap.classList.contains('price--on-sale');

      if (onSale) {
        var onSaleWrap = document.querySelector('.price--on-sale');
        var saleEl = onSaleWrap ? onSaleWrap.querySelector('.price-item--sale') : null;
        // Try multiple selectors — theme variants differ in compare-at price location
        var compEl = onSaleWrap ? (
          onSaleWrap.querySelector('.price__sale .price-item--regular') ||
          onSaleWrap.querySelector('s.price-item--regular') ||
          onSaleWrap.querySelector('.price__compare .price-item--regular')
        ) : null;

        if (saleEl) priceNew.textContent = saleEl.textContent.trim();
        if (compEl) { priceOld.textContent = compEl.textContent.trim(); } else { priceOld.textContent = ''; }

        var sale = parseAmount(saleEl ? saleEl.textContent : '');
        var comp = parseAmount(compEl ? compEl.textContent : '');
        if (sale && comp && comp > sale) {
          var _saveCents = Math.round((comp - sale) * 100);
          var _saveEur = Math.floor(_saveCents / 100);
          var _saveRem = _saveCents % 100;
          // 16-07-2026: tekst omgezet van "Bespaar <euro> X" naar "<euro> X korting".
          // Euroteken blijft als escape geschreven: dit gaat via textContent, dus een
          // HTML-entity zou hier letterlijk in beeld komen.
          badge.textContent = _saveRem === 0 ? '\u20AC ' + _saveEur + ',- korting' : '\u20AC ' + _saveEur + ',' + (_saveRem < 10 ? '0' : '') + _saveRem + ' korting';
        } else {
          // Fallback: read the badge the theme already rendered
          var pageBadge = document.querySelector('.price__badge-sale');
          badge.textContent = pageBadge ? pageBadge.textContent.trim() : '';
        }
      } else {
        var regEl = document.querySelector('.price__regular .price-item--regular');
        if (regEl) priceNew.textContent = regEl.textContent.trim();
        priceOld.textContent = '';
        badge.textContent = '';
      }
    }
    updatePrice();
    // Re-run after variant JS may have updated price classes
    setTimeout(updatePrice, 300);

    // Variant selector — mirror first option group from page
    function buildVariants() {
      varSel.innerHTML = '';

      // Try variant-selects (select element)
      var mainSelect = document.querySelector('variant-selects select');
      if (mainSelect && mainSelect.options.length > 1) {
        Array.from(mainSelect.options).forEach(function (opt) {
          var o = new Option(opt.text, opt.value, opt.selected, opt.selected);
          varSel.appendChild(o);
        });
        varSel.style.display = '';
        return;
      }

      // Try variant-radios (first fieldset = color/first option)
      var firstFieldset = document.querySelector('variant-radios fieldset');
      if (firstFieldset) {
        var inputs = firstFieldset.querySelectorAll('input[type="radio"]');
        if (inputs.length > 1) {
          inputs.forEach(function (input) {
            var o = new Option(input.value, input.value, input.checked, input.checked);
            varSel.appendChild(o);
          });
          varSel.style.display = '';
          return;
        }
      }

      // No variants or single variant — hide selector
      varSel.style.display = 'none';
    }
    buildVariants();

    // Sync sticky variant → main page
    varSel.addEventListener('change', function () {
      var val = this.value;

      var mainSelect = document.querySelector('variant-selects select');
      if (mainSelect) {
        mainSelect.value = val;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      var radio = document.querySelector(
        'variant-radios fieldset input[value="' + CSS.escape(val) + '"]'
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Sticky ATC click → trigger main button
    stickyBtn.addEventListener('click', function () {
      if (atcBtn && !atcBtn.disabled) {
        stickyBtn.classList.add('wb-sticky-atc__btn--loading');
        atcBtn.click();
        setTimeout(function () {
          stickyBtn.classList.remove('wb-sticky-atc__btn--loading');
        }, 1500);
      }
    });

    // Show / hide on scroll via IntersectionObserver.
    // Only reveal after the ATC button has been visible at least once
    // (prevents pop-up on load when button starts below the fold).
    // threshold:0 — hide the bar the instant any pixel of the button is visible.
    // buttonIsAbove guard — only show when the button has exited the TOP of the
    // viewport (user scrolled past it going down). When the button is below the
    // viewport (user at the top of the page, button not yet reached), top > 0 so
    // buttonIsAbove is false and the bar stays hidden.
    if ('IntersectionObserver' in window) {
      var buttonEverVisible = false;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            buttonEverVisible = true;
          }

          var soldOut = atcBtn.disabled || atcBtn.getAttribute('aria-disabled') === 'true';
          var buttonIsAbove = entry.boundingClientRect.top < 0;

          if (!entry.isIntersecting && buttonEverVisible && !soldOut && buttonIsAbove) {
            bar.classList.add('wb-sticky-atc--visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('wb-sticky-atc--visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        });
      }, { threshold: 0 });

      io.observe(atcBtn);
    }

    // React to variant changes on the main page
    document.addEventListener('change', function (e) {
      if (!e.target.closest('variant-selects, variant-radios')) return;
      setTimeout(function () {
        updatePrice();
        updateThumb();
        buildVariants();
        var soldOut = atcBtn.disabled || atcBtn.getAttribute('aria-disabled') === 'true';
        if (soldOut) bar.classList.remove('wb-sticky-atc--visible');
      }, 350);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
